import { CommandProps } from '@tiptap/core';
import { liftTarget } from '@tiptap/pm/transform';

/**
 * Lifts the nearest ancestor node of the requested type around the current cursor.
 */
export default function unwrapAncestorNode({ state, tr, dispatch }: CommandProps, nodeType: string) {
  const type = state.schema.nodes[nodeType];
  const { $anchor } = state.selection;

  if (!type) {
    return false;
  }

  for (let depth = $anchor.depth; depth > 0; depth -= 1) {
    if ($anchor.node(depth).type !== type) {
      continue;
    }

    const $from = state.doc.resolve($anchor.start(depth));
    const $to = state.doc.resolve($anchor.end(depth));
    const range = $from.blockRange($to);

    if (!range) {
      return false;
    }

    const target = liftTarget(range);

    if (target === null || target === undefined) {
      return false;
    }

    if (dispatch) {
      dispatch(tr.lift(range, target).scrollIntoView());
    }

    return true;
  }

  return false;
}
